<template>
    <div
        class="CardRowLoadingIndicator grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4"
        :class="singleRow ? 'grid-rows-1' : 'grid-rows-2'"
    >
        <CardContentLoader v-for="(item, index) in itemsArray" :key="index" />
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    items: {
        type: Number,
        default: 4
    },
    singleRow: {
        type: Boolean,
        default: false
    }
})

const getRows = computed(() => {
    return props.singleRow ? 1 : 2
})

const getItems = computed(() => {
    if (import.meta.client) {
        if (window.innerWidth > 1200) {
            return 4 * getRows.value
        } else if (window.innerWidth > 992) {
            return 3 * getRows.value
        } else if (window.innerWidth > 576) {
            return 2 * getRows.value
        } else if (window.innerWidth < 576) {
            return 4 * getRows.value
        }
        return 4
    }
    return 4
})

const itemsArray = computed(() => {
    if (props.items === 4) {
        return [...new Array(getItems.value)].map(() => ({}))
    } else {
        return [...new Array(props.items)].map(() => ({}))
    }
})
</script>
